import React from 'react'
import MaterialMenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'

import { Icon, Icons } from 'src/chrome'

import styles from '../contactActionBar.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'

interface Props {
  onClick: () => void
  icon: Icons
  text: string
  isDisabled?: boolean
  iconViewBox?: string
  show?: Array<'sm' | 'md'>
  id?: string
}

const MenuItem: React.FC<Props> = props => {
  const { onClick, isDisabled, icon, iconViewBox, text, show = [], id } = props

  return (
    <MaterialMenuItem
      id={id}
      className={`
        ${show.length ? styles.hide : ''}
        ${show.includes('sm') ? styles.showSm : ''}
        ${show.includes('md') ? styles.showMd : ''}
      `}
      onClick={onClick}
    >
      <ListItemIcon>
        <Icon
          icon={icon}
          color={isDisabled ? '#6f8394' : '#ff5689'}
          size={20}
          viewBox={iconViewBox}
        />
      </ListItemIcon>
      <Text type="body" color="primaryHeading">
        {text}
      </Text>
    </MaterialMenuItem>
  )
}

export default MenuItem
